import { combineReducers } from 'redux'
import activeServerReducer from './activeServer/reducer'
import textsReducer from './texts/reducer'
import playableReducer from './playable/reducer'
import processReducer from './process/reducer'
import progressReducer from './progress/reducer'
import serverProfilesReducer from './serverProfiles/reducer'
import serversReducer from './servers/reducer'
import settingsReducer from './settings/reducer'
import versionsReducer from './versions/reducer'
import readyReducer from './ready/reducer'

const reducer = combineReducers({
    activeServer: activeServerReducer,
    texts: textsReducer,
    playable: playableReducer,
    process: processReducer,
    progress: progressReducer,
    serverProfiles: serverProfilesReducer,
    servers: serversReducer,
    settings: settingsReducer,
    versions: versionsReducer,
    ready: readyReducer,
})

export default reducer



// WEBPACK FOOTER //
// ./src/features/Backend/data/reducer.js